import { render, staticRenderFns } from "./NavBarAccount.layout.vue?vue&type=template&id=f1a5655e&"
import script from "./NavBarAccount.layout.vue?vue&type=script&lang=ts&"
export * from "./NavBarAccount.layout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports